var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#F0F0F0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3435 5055 c-14 -13 -25 -32 -25 -41 0 -9 95 -339 210 -733 222 -756 220 -751 279 -751 40 0 60 26 160 209 l89 163 45 -64 c220 -308 358 -682 397 -1077 50 -510 -97 -1059 -397 -1479 l-45 -63 -95 172 c-52 95 -102 179 -111 186 -24 18 -66 16 -91 -4 -15 -14 -71 -190 -233 -741 -201 -687 -211 -725 -197 -750 32 -57 13 -61 775 162 390 114 720 216 734 225 33 24 39 82 11 108 -11 10 -113 69 -226 132 -119 65 -204 118 -202 125 3 6 35 52 72 101 225 302 388 663 470 1041 44 205 58 343 58 584 0 309 -32 529 -117 810 -95 312 -261 631 -455 874 -17 21 -31 42 -31 47 0 4 93 59 206 121 113 62 214 121 225 131 25 24 25 78 -1 102 -19 17 -1421 435 -1461 435 -11 0 -31 -11 -44 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 4972 c-64 -39 -73 -123 -21 -190 90 -119 1212 -1494 1244 -1524 32 -32 45 -38 82 -38 30 0 54 7 75 23 25 17 1111 1342 1259 1535 27 36 33 52 33 94 0 44 -4 54 -34 84 l-34 34 -1288 0 c-1196 -1 -1291 -2 -1316 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 2705 c-47 -28 -83 -91 -83 -145 0 -55 36 -117 85 -145 l42 -25 1426 2 c1422 3 1426 3 1453 24 104 77 104 211 0 288 -27 21 -31 21 -1454 23 l-1427 3 -42 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302 1884 c-31 -22 -1280 -1558 -1292 -1589 -21 -55 0 -119 49 -148 27 -16 121 -17 1316 -17 l1287 0 34 34 c30 30 34 40 34 84 0 42 -6 58 -33 94 -148 193 -1234 1518 -1259 1536 -37 26 -103 30 -136 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipRight);
export default __webpack_public_path__ + "static/media/flip-right.5bb8f5fa9f7b1e8f21a7ce41936eb239.svg";
export { ForwardRef as ReactComponent };